import React from 'react';
import PlatformCostSummaryCostTypesEnum from '../../../Enums/PlatformCostSummaryCostTypesEnum';

export default class TpPlatformInvoiceSummaryItem {
  constructor(item) {
    if (item === undefined) {
      this.PlatformCostSummaryId = '';
      this.BillingPeriod = '';
      this.CostType = '';
      this.OfficeName = '';
      this.ClientName = '';
      this.TpJobShopCount = '';
      this.ThirdPartyShopCountApi = '';
      this.TotalAmount = '';
      this.ThirdPartyAmountApi = '';
      this.CurrencyCode = '';
      this.OfficeId = '';
      this.ClientId = '';
      return;
    }
    this.PlatformCostSummaryId = item.platformCostSummaryId;
    this.BillingPeriod = item.billingPeriod ?? '';
    this.CostType = item.costType ? item.costType : '';
    this.OfficeName = item.officeName ? item.officeName : '';
    this.ClientName = item.clientName ? item.clientName : '';
    this.TpJobShopCount = item.tpJobShopCount ?? '';
    this.ThirdPartyShopCountApi = item.thirdPartyShopCountApi ?? '';
    this.TotalAmount = item.totalAmount ?? '';
    this.ThirdPartyAmountApi = item.thirdPartyAmountApi ?? '';
    this.CurrencyCode = item.currencyCode ? item.currencyCode : '';
    this.OfficeId = item.officeId ?? '';
    this.ClientId = item.clientId ?? '';
  }

  static displayedInList = 'ClientName';

  static NameOfTheIdField() {
    return 'PlatformCostSummaryId';
  }

  static nameOfTheItemDetailList() {
    return 'Platform Cost Summary Row';
  }

  // Bravo's amount and the platform's, both in the summary row's own currency; the per-cost-type
  // subclasses inherit these and their string-named money columns.
  static MoneyFields = ['TotalAmount', 'ThirdPartyAmountApi'];
  static Currency() {
    return 'CurrencyCode';
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [];

  // Bound by TpPlatformInvoiceCostSummaryTab — opens the per-client Bravo-jobs popup.
  static showBravoJobsFunction = (item) => {
    alert('Empty function');
  };

  // Assignment rows with a positive count link to the actual billed TpJobs behind the
  // number; every other row (other cost types, zero/empty counts) stays plain text.
  static getBravoShopCountCellContent(item) {
    if (item.CostType !== PlatformCostSummaryCostTypesEnum.Assignment || !(item.TpJobShopCount > 0)) {
      return item.TpJobShopCount;
    }
    return (
      <a
        href='#!'
        onClick={(e) => {
          e.preventDefault();
          TpPlatformInvoiceSummaryItem.showBravoJobsFunction(item);
        }}
        title='Show the billed Bravo jobs behind this count'
      >
        {item.TpJobShopCount}
      </a>
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Cost Type',
        orderById: 'CostType',
        data: 'CostType',
        className: 'text-left',
        minWidth: 60,
      },
      {
        label: 'Office',
        orderById: 'OfficeName',
        data: 'OfficeName',
        className: 'text-left',
        minWidth: 60,
      },
      {
        label: 'Caspian Client',
        orderById: 'ClientName',
        data: 'ClientName',
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Bravo Shop Count',
        orderById: '',
        data: (item) => TpPlatformInvoiceSummaryItem.getBravoShopCountCellContent(item),
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Platform Shop Count',
        orderById: '',
        data: 'ThirdPartyShopCountApi',
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Amount',
        orderById: '',
        data: 'TotalAmount',
        className: 'text-right',
        minWidth: 40,
      },
      {
        label: 'Platform Amount',
        orderById: '',
        data: 'ThirdPartyAmountApi',
        className: 'text-right',
        minWidth: 40,
      },
    ];
  }
}
